import { useFormFactory } from '@meilleurtaux/form-factory'
import { PopUpInternauteReconnu, useTracking } from '@meilleurtaux/form-factory-ds'
import { useEffect } from 'react'
import { getRedirectUrl } from 'utils/internauteReconnu'

interface InternauteReconnuProps {
  userSheetId: string | null
}

const InternauteReconnu = ({ userSheetId }: InternauteReconnuProps) => {
  const { closeInternauteReconnu, internauteReconnu } = useFormFactory(import.meta.env.VITE_API_URL)
  const { trackModalOpen, trackModalClose } = useTracking()

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)

    if (internauteReconnu?.redirect) {
      window.location.href = getRedirectUrl(queryParams)
    }
  }, [internauteReconnu?.redirect])

  useEffect(() => {
    if (!userSheetId || !internauteReconnu || internauteReconnu.redirect) return
    if (internauteReconnu?.openPopUp) {
      trackModalOpen({ title: '', type: 'internaute_reconnu' })
    } else {
      trackModalClose({ title: '', type: 'internaute_reconnu' })
    }
  }, [
    internauteReconnu?.openPopUp,
    trackModalOpen,
    trackModalClose,
    userSheetId,
    internauteReconnu,
  ])

  if (!userSheetId || !internauteReconnu) return null

  return (
    <PopUpInternauteReconnu
      open={internauteReconnu.openPopUp}
      firstName={internauteReconnu.firstName ?? ''}
      userSheetId={userSheetId}
      toggleAndisNotMe={closeInternauteReconnu}
    />
  )
}

export default InternauteReconnu
